import React, { useCallback } from 'react'

import { searchSelectRecentDestination } from 'analytics/eventDefinitions'
import { addGTMEvent } from 'api/googleTagManager'
import LocationSearchFieldListOption from './LocationSearchFieldListOption'
import BodyText from 'components/Luxkit/Typography/BodyText'
import styled from 'styled-components'
import { rem } from 'polished'

const OptionsListContainer = styled.div`
  text-align: left;
  > .search-menu-list-item {
    margin-top: ${rem(16)};
  }
  > .search-menu-list-item ~ .search-menu-list-item {
    margin-top: 0;
  }
`
const OptionsListLabel = styled(BodyText)`
  text-align: left;
  color:  ${({ theme }) => theme.palette.neutral.two};
`

interface Props {
  recentSearchItems: App.SearchItem[];
  setValue: (item: App.SearchItem) => void;
}

function RecentLocationsSearch(props: Props) {
  const { recentSearchItems, setValue } = props

  const handleRecentLocationClick = useCallback((
    searchItem: App.SearchItem,
    e: React.MouseEvent<HTMLElement>,
  ) => {
    e.stopPropagation()

    setValue(searchItem)

    if (searchItem.searchType === 'destination') {
      addGTMEvent(searchSelectRecentDestination(searchItem))
    }
  }, [setValue])

  return (
    <OptionsListContainer>
      <OptionsListLabel variant="small">Places you recently searched</OptionsListLabel>

      {recentSearchItems?.map((searchItem) => <LocationSearchFieldListOption
        key={searchItem.value}
        searchItem={searchItem}
        onClick={handleRecentLocationClick}
      />)}
    </OptionsListContainer>
  )
}

export default RecentLocationsSearch
